import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  Stack,
} from '@mui/material'
import errorSound from '../../../Assets/Sounds/error.mp3'
import { stackGap } from '../../../Constants&Theme/Spacing'

function SlowDownDialog({
  open,
  lastScan,
}: {
  open: number | null
  lastScan: number
}) {
  // FIXME: duration confirmed to be correct, but determinate progress not reflected correctly

  // console.log(
  //   open ? (open - simplify) / 1000 : null,
  //   lastScan ? (lastScan - simplify) / 1000 : null,
  // )
  // Percentage (in range 0-100)
  // const [progress, setProgress] = useState(0)
  // useEffect(() => {
  //   if (open) {
  //     // console.log(
  //     //   new Date(open).toLocaleTimeString(),
  //     //   new Date(lastScan).toLocaleTimeString(),
  //     // )
  //     const timer = setInterval(() => {
  //       const timeoutTotal = lastScan - open + timeoutDuration
  //       setProgress(((Date.now() - lastScan) / timeoutTotal) * 100)
  //     }, 100)
  //     return () => {
  //       clearInterval(timer)
  //     }
  //   } else {
  //     setProgress(0)
  //   }
  // }, [lastScan, open])

  return (
    <Dialog open={!!open}>
      <DialogTitle>{'Slow Down!'}</DialogTitle>
      <DialogContent>
        <audio
          src={errorSound}
          autoPlay
        />
        <DialogContentText>You are scanning too fast!</DialogContentText>
        <Stack
          sx={{ mt: 1 }}
          direction={'row'}
          gap={stackGap.row}
        >
          <LinearProgress
            sx={{ width: 300 }}
            // variant="determinate"
            // value={progress}
          />
          {/*<Typography*/}
          {/*  variant="body2"*/}
          {/*  sx={{ width: 40 }}*/}
          {/*>{`${Math.round((progress * (timeoutDuration / 1000)) / 100)}s`}</Typography>*/}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default SlowDownDialog
